function Executive() {
  return <div>Executive</div>;
}

export default Executive;
